import React, { useState, useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import qrCodeBorder from "../../assets/images/qr-code-border.svg";
import { SHARE_QR } from "../../utils/constants/common";
import qrCodeLogo from "../../assets/images/sidebar_icons/logoIcon.png";
import { GiShare } from "react-icons/gi";
import baseUrl from "../../utils/constants/baseUrl";
import Loader from "../../components/Loader";
import { useAtom } from "jotai";
import {
  DYNAMIC_QRCODE,
  CUSTOMIZE_QRCODE,
  IMAGE_UPLOAD,
} from "../../utils/constants/apiUrl";
import { get, post, put } from "../../server";
import showToast from "../../helpers/showToast";
import formatPhoneNumber from "../../helpers/formatPhoneNumber";
import ImageUploadSquare from "../../components/ImageUploadSquare";
import removeQrLogo from "../../assets/images/function_page_icons/nocamera.svg";
import { Button, Form } from "react-bootstrap";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  loggedInUser,
  teamIDCheck,
  subscribedPackage,
} from "../../utils/store";
import useFunctionsCount from "../../hooks/useFunctionsCount";
import functionTypes from "../../utils/constants/functionTypes";
import FormInput from "../../components/Forms/FormInput";
import { trackEvent } from "../../utils/mixpanel";
const AddEditQRCodePage = ({}) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [teamID, setTeamID] = useAtom(teamIDCheck);
  const [loading, setLoading] = useState(false);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [bgColor, setBgColor] = useState("#ffffff");
  const [fgColor, setFgColor] = useState("#000000");
  const [editBgColor, setEditBgColor] = useState(bgColor);
  const [editFgColor, setEditFgColor] = useState(fgColor);
  const [logoImageURL, setLogoImageURL] = useState(qrCodeLogo);
  const [editLogoImageURL, setEditLogoImageURL] = useState(logoImageURL);
  const [shouldRemoveLogo, setShouldRemoveLogo] = useState(false);
  const [data, setData] = useState({});
  const [image, selectImage] = useState("");
  const navigate = useNavigate();
  let { id } = useParams();
  const [functionType, setFunctionTypes] = useState({
    card: false,
    payment: false,
    emergency_contact: false,
    custom_url: false,
    file_upload: false,
    memory: false,
    medical_id: false,
    form_builder: false,
  });
  const [label, setLabel] = useState();
  const { compareLimits, updateCount, updateUserActionsForDynamicQRCode } =
    useFunctionsCount();
  const getQRDetails = async (e) => {
    setLoading(true);
    if (id) {
      let { status, message, data } = await get(
        `${DYNAMIC_QRCODE}/${id}`,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );
      if (status) {
        setData(data);
        const functionTypesFromApi = {};
        data.dynamicQRCodeFunctions.forEach((item) => {
          functionTypesFromApi[item.function_type] = true;
        });
        setLabel(data.label);
        setFunctionTypes(functionTypesFromApi);
        setEditBgColor(data?.qrCodeCustomize?.qr_bg_color || "#ffffff");
        setEditFgColor(data?.qrCodeCustomize?.qr_front_color || "#000000");
        setEditLogoImageURL(
          baseUrl.PUBLIC_URL + data?.qrCodeCustomize?.qr_image || qrCodeLogo
        );
      } else {
        showToast(status, message);
      }
    }
    setLoading(false);
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFunctionTypes((prevTypes) => ({
      ...prevTypes,
      [name]: checked,
    }));
  };
  const handleChange = (e) => {
    console.log("Event Value:", e.target.value);
    setLabel(e.target.value);
  };
  // const handleRemoveLogoImage = async (e) => {
  //   const removeLogoPayload = {
  //     id: id,
  //     function_type: "dynamic_qr_code",
  //     function_id: id,
  //     qr_bg_color: editBgColor,
  //     qr_front_color: editFgColor,
  //     qr_image: null,
  //   };
  //   let { status, message, data } = await post(
  //     CUSTOMIZE_QRCODE,
  //     removeLogoPayload,
  //     Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
  //   );

  //   if (status) {
  //     setLogoImageURL("");
  //     setEditLogoImageURL("");
  //     setShouldRemoveLogo(true);
  //   } else {
  //     showToast(status, message);
  //   }
  // };
  const handleRemoveLogoImage = async () => {
    // 1️⃣ Remove locally first (so QR updates immediately)
    selectImage(""); // clear newly selected
    setLogoImageURL("");
    setEditLogoImageURL("");
    setShouldRemoveLogo(true);

    // 2️⃣ Only call API if in edit mode (id exists)
    if (id) {
      const removeLogoPayload = {
        id: id,
        function_type: "dynamic_qr_code",
        function_id: id,
        qr_bg_color: editBgColor,
        qr_front_color: editFgColor,
        qr_image: null,
      };
      let { status, message } = await post(
        CUSTOMIZE_QRCODE,
        removeLogoPayload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      showToast(status, message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (shouldRemoveLogo) {
      await handleRemoveLogoImage();
    }
    let uploadedImageUrl = "";
    if (image && typeof image === "object") {
      let formDataObj = new FormData();
      formDataObj.append("image_type", "dynamic_qr_code");
      formDataObj.append("image", image);

      try {
        let { status, message, data } = await post(
          IMAGE_UPLOAD,
          formDataObj,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );

        if (status) {
          uploadedImageUrl = data || "";
          setLogoImageURL(uploadedImageUrl);
          setEditLogoImageURL(uploadedImageUrl);
        } else {
          showToast(status, message);
          setLoading(false);
          return;
        }
      } catch (error) {
        setLoading(false);
        return;
      }
    }

    const payload = {
      function_types: Object.keys(functionType).filter(
        (key) => functionType[key]
      ),
      // function_types: Object.entries(functionTypes)
      //   .filter(([key, ids]) => ids.length > 0)
      //   .map(([key, ids]) => ({
      //     function_name: key,
      //     function_ids: ids,
      //   })),
      team_id: teamID,
      label: label,
    };
    console.log("payload", payload);
    try {
      let response;
      if (id) {
        response = await put(
          `${DYNAMIC_QRCODE}/${id}`,
          payload,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );
      } else {
        response = await post(
          DYNAMIC_QRCODE,
          payload,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );
      }

      if (response.status) {
        trackEvent(id ? "Dynamic QR Updated" : "Dynamic QR Created", {
          function_id: response.data?.id,
          function_types: payload.function_types,
          team_id: teamID,
          label,
          qr_bg_color: editBgColor,
          qr_front_color: editFgColor,
          qr_image: uploadedImageUrl,
          plan_type:
            purchasedPackage?.id === 1
              ? "Starter"
              : purchasedPackage?.package_name || "Paid",
          user_id: loggedUser?.id,
        });
        updateCount(functionTypes.DYNAMIC_QR_CODE, functionTypes.ADD);
        const functionId = response.data.id;

        const customPayload = {
          id: id,
          function_type: "dynamic_qr_code",
          function_id: functionId,
          qr_bg_color: editBgColor,
          qr_front_color: editFgColor,
          qr_image: uploadedImageUrl,
        };

        const customizeResponse = await post(
          CUSTOMIZE_QRCODE,
          customPayload,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );

        if (customizeResponse.status) {
          if (functionId) {
            updateUserActionsForDynamicQRCode(functionId);
          }
          if (!functionId) {
            updateCount(functionTypes.DYNAMIC_QR_CODE, functionTypes.ADD);
          }
          navigate("/qrcode");
        } else {
          showToast(customizeResponse.status, customizeResponse.message);
        }
        showToast(response.status, response.message);
      } else {
        showToast(response.status, response.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }

    setLoading(false);
  };
  useEffect(() => {
    getQRDetails();
  }, []);
  return (
    <>
      <div>
        <div className="row align-items-center">
          <div className="col-6 heading">
            <h1 className="title"> {id ? "Edit" : "Add"} QR Code</h1>
          </div>
        </div>
        <div className="">
          <>
            <div className="row">
              <div className="col-md-6 col-12 text">
                <div className="qrWrapper mt-0">
                  <div className="qrCodeInner">
                    <div className="qrCode">
                      <div className="modalGradientCircle"></div>
                      <img src={qrCodeBorder} />

                      <QRCode
                        // value={url ? url : `${SHARE_QR}dynamic_qr_code/${uuid}`}
                        id="qrCodeEl"
                        // logoImage={
                        //   editLogoImageURL ? editLogoImageURL : qrCodeLogo
                        // }
                        logoImage={
                          image
                            ? typeof image === "object"
                              ? URL.createObjectURL(image) // show preview
                              : baseUrl.PUBLIC_URL + image
                            : editLogoImageURL || logoImageURL || qrCodeLogo
                        }
                        logoOpacity={1}
                        logoPadding={3}
                        bgColor={
                          editBgColor
                            ? editBgColor
                            : data.qrCodeCustomize.qr_bg_color
                        }
                        fgColor={
                          editFgColor
                            ? editFgColor
                            : data.qrCodeCustomize.qr_front_color
                        }
                        eyeRadius={0}
                        removeQrCodeBehindLogo
                      />
                    </div>
                    {/* {id && ( */}
                    <ul className={`customizedSidebar list-unstyled m-0`}>
                      <li className="mb-4">
                        <ImageUploadSquare
                          selectedImage={
                            typeof image == "object"
                              ? image
                              : baseUrl.PUBLIC_URL + image
                          }
                          setSelectedImage={selectImage}
                        />
                      </li>
                      <li className="mb-4">
                        {/* <button
                          className="removeImgBtn"
                          onClick={handleRemoveLogoImage}
                        >
                          <img src={removeQrLogo} />
                        </button> */}
                        <button
                          className="removeImgBtn"
                          onClick={handleRemoveLogoImage}
                          disabled={
                            !image && !editLogoImageURL && !logoImageURL
                          }
                        >
                          <img src={removeQrLogo} />
                        </button>
                      </li>
                      <li className="mb-4">
                        <Form.Group controlId="">
                          <input
                            type="color"
                            //value={}
                            className="colorPicker"
                            //onChange={handleBgColorChange}
                            onChange={(e) => setEditBgColor(e.target.value)}
                          />
                        </Form.Group>
                      </li>
                      <li>
                        <Form.Group controlId="">
                          <input
                            type="color"
                            //value={}
                            className="colorPicker"
                            //onChange={handleFgColorChange}
                            onChange={(e) => setEditFgColor(e.target.value)}
                          />
                        </Form.Group>
                      </li>
                    </ul>
                    {/* )} */}
                  </div>
                  <hr />
                  <div className="text-start">
                    <FormInput
                      type="text"
                      label="Label"
                      name="label"
                      placeholder="Enter label here"
                      value={label}
                      handleChange={handleChange}
                      // error={errors.first_name}
                    />
                  </div>
                  <h6
                    style={{
                      margin: "10px 0 20px",
                      textAlign: "left",
                      fontSize: "14px",
                    }}
                  >
                    Choose Functions
                  </h6>
                  <div className="row text-start">
                    <div className="col-sm-6 col-12">
                      <div className="box-pill form-group d-flex justify-content-between align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="card"
                            checked={functionType.card}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="card">
                            Digital Cards
                          </label>
                        </div>
                        {/* {id ? (
                          ""
                        ) : (
                          <Link to="/dynamicQRCode/function/cards">
                            <button className="primary_button px-3 py-1">
                              Add
                            </button>
                          </Link>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="box-pill form-group d-flex justify-content-between align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="payment"
                            checked={functionType.payment}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="payment">
                            Payment Service
                          </label>
                        </div>
                        {/* {id ? (
                          ""
                        ) : (
                          <Link to="/function/paymentListing">
                            <button className="primary_button px-3 py-1">
                              Add
                            </button>
                          </Link>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="box-pill form-group d-flex justify-content-between align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="emergency_contact"
                            checked={functionType.emergency_contact}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="emergency_contact"
                          >
                            Emergency Contact
                          </label>
                        </div>
                        {/* {id ? (
                          ""
                        ) : (
                          <Link to="/function/emergencycontacts">
                            <button className="primary_button px-3 py-1">
                              Add
                            </button>
                          </Link>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="box-pill form-group d-flex justify-content-between align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="custom_url"
                            checked={functionType.custom_url}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="custom_url"
                          >
                            Custom URL’s
                          </label>
                        </div>
                        {/* {id ? (
                          ""
                        ) : (
                          <Link to="/function/customurlslisting">
                            <button className="primary_button px-3 py-1">
                              Add
                            </button>
                          </Link>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="box-pill form-group d-flex justify-content-between align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="file_upload"
                            checked={functionType.file_upload}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="file_upload"
                          >
                            File Upload URL
                          </label>
                        </div>
                        {/* {id ? (
                          ""
                        ) : (
                          <Link to="/function/fileupload">
                            <button className="primary_button px-3 py-1">
                              Add
                            </button>
                          </Link>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="box-pill form-group d-flex justify-content-between align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="memory"
                            checked={functionType.memory}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="memory">
                            Memory
                          </label>
                        </div>
                        {/* {id ? (
                          ""
                        ) : (
                          <Link to="/function/memoryListing">
                            <button className="primary_button px-3 py-1">
                              Add
                            </button>
                          </Link>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="box-pill form-group d-flex justify-content-between align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="medical_id"
                            checked={functionType.medical_id}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="medical_id"
                          >
                            Medical ID
                          </label>
                        </div>
                        {/* {id ? (
                          ""
                        ) : (
                          <Link to="/function/medicalListing">
                            <button className="primary_button px-3 py-1">
                              Add
                            </button>
                          </Link>
                        )} */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="box-pill form-group d-flex justify-content-between align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="form_builder"
                            checked={functionType.form_builder}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="form_builder"
                          >
                            Lead Builder
                          </label>
                        </div>
                        {/* {id ? (
                          ""
                        ) : (
                          <Link to="/function/formBuilder">
                            <button className="primary_button px-3 py-1">
                              Add
                            </button>
                          </Link>
                        )} */}
                      </div>
                    </div>
                  </div>
                  <div className="btnWrapper mobileViewWrapper d-block text-center px-3 mt-3">
                    <Button
                      variant="primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? "Saving.." : "Save"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
      <style type="text/css">
        {`
          .box-pill{
            background-color: var(--body-color);
            border-radius: 10px;
            padding: .75rem;
            margin-bottom:.75rem;
            width:100%;
          }
          .form-check-label{
            font-size:13px;
          }
          .imageWrapper {
            position: relative;
            width: 16px !important;
            height: 16px !important;
            margin: auto;
          }
          .imageWrapper::before{
            background:transparent !important;
          }
          .imageWrapper img{display:none;}
          .imageWrapper .icon {
            color:#09A0FF;
            font-size:18px
          }
          .customizedSidebar{
            background-color: DAE9F4;
            border-radius: 10px;
            padding: 15px;
            height:fit-content;
            position:absolute;
            top : 30px;
            right : 0
          }
          .customizedSidebar li img{
            width: 16px !important;
            height: 16px !important;
            margin-right : 100%;
          }
          .customizedSidebar li input{
            width: 16px;
            height: 16px;
            border: 0;
            padding: 0;
            border-radius:50%;
          }
          .customizedSidebar li button{
            background-color:transparent;
            border:0;
            padding:0;
          }
            .imageWrapper{
            margin: 0
            }
        `}
      </style>
    </>
  );
};
export default AddEditQRCodePage;
